import script from "./mlogin.vue?vue&type=script&setup=true&lang=js"
export * from "./mlogin.vue?vue&type=script&setup=true&lang=js"

import "./mlogin.vue?vue&type=style&index=0&id=64a071e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64a071e8"]])

export default __exports__